// The venue's business areas — the outlet axis every PMS mapping resolves through
// (see DLIntegratorServer docs/INTEGRATION_SETUP_DESIGN.md). Until now they could only
// be created from the POS side; the PMS matrix work made them setup data, so they are
// managed here like departments: add by name, rename inline.
//
// Deleting one that documents or a mapping matrix reference breaks their resolution —
// prefer renames. (Same caveat as every entity this screen family manages.)
class BusinessAreaViewController extends SingleEditViewController
{
    static newInstance() : BusinessAreaViewController
    {
        let vc = new BusinessAreaViewController("single-edit-view");
        vc.initWithResource("layout/base/SingleEditView.html");
        return vc;
    }

    get title(){
        return MIOLocalizeString("BUSINESS_AREAS","BUSINESS AREAS");
    }

    fetchEntity(){
        return "BusinessArea";
    }

    sortDescriptors(){
        return [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
    }

    configureCellAtIndexPath(cell:SingleEditCell, indexPath:MIOIndexPath, item:MIOManagedObject){
        let area = item as BusinessArea;
        cell.setItem(area, "name");
    }

    addButtonDidPress(){

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_BUSINESS_AREA", "NEW BUSINESS AREA"), MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
           textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD","ADD"), MUIAlertActionStyle.Default, this, function(){
            let name = avc.textFields[0].text.trim();
            if (name.length == 0) return;
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let area = MIOEntityDescription.insertNewObjectForEntityForName(this.fetchEntity(), ad.managedObjectContext) as BusinessArea;
            area.name = name;

            ad.managedObjectContext.save();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    removeItem(item:MIOManagedObject){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.managedObjectContext.deleteObject(item);
        ad.managedObjectContext.save();
    }
}
